// extracted by mini-css-extract-plugin
export default {"card":"GameCard_card__Y9oVK","image":"GameCard_image__5VFuN","title":"GameCard_title__NYYZl","status":"GameCard_status__3DAvs"};